import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children", "open", "icon", "noBorder", "noLabel"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Icon from '../Icon';
import Label from '../Label';
import { isEmpty } from '../tools/util';
import BaseInput from '../BaseInput'; // 筛选按钮

export default function Selector(_ref) {
  var className = _ref.className,
      children = _ref.children,
      open = _ref.open,
      icon = _ref.icon,
      noBorder = _ref.noBorder,
      noLabel = _ref.noLabel,
      others = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(BaseInput, _extends({
    className: classNames('jmtd-selector', className, {
      'jmtd-selector-no-border': noBorder
    }),
    empty: isEmpty(children),
    focused: open,
    startIcon: null,
    endIcon: icon
  }, others), noLabel ? children : /*#__PURE__*/React.createElement(Label, {
    theme: "light"
  }, children));
}
Selector.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  open: PropTypes.bool,
  placeholder: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  widthAdaptive: PropTypes.bool,
  icon: PropTypes.node,
  right: PropTypes.node,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']),
  onClear: PropTypes.func,
  allowClear: PropTypes.bool,
  noBorder: PropTypes.bool,
  noLabel: PropTypes.bool
};
Selector.defaultProps = {
  children: null,
  className: '',
  open: false,
  placeholder: null,
  width: null,
  widthAdaptive: null,
  icon: /*#__PURE__*/React.createElement(Icon, {
    className: "jmtd-selector-arrow jmti-angle-down"
  }),
  right: null,
  size: null,
  onClear: function onClear() {},
  allowClear: false,
  noBorder: false,
  noLabel: false
};